// import SolrFileJSON from '@/assets/data/sig_table/solr.response.json'
function genearteUniversalIds(original) {
  let clone = JSON.parse(JSON.stringify(original))
  let dimsToReplace = {}
  clone.dims.forEach(dim => {
    if (dim.type !== 'time' && dim.type !== 'location') {
      dim.values = dim.values.map((v, i) => {
        return {
          id: dim.id + '_val_' + i,
          label: v || '-',
        }
      })
      dimsToReplace[dim.id] = dim.values
    }
  })
  clone.values.forEach(row => {
    Object.keys(row).forEach(key => {
      if (dimsToReplace[key]) {
        row[key] = dimsToReplace[key].find(dd => dd.label === (row[key] || '-')).id
      }
    })
  })
  return clone
}
export function getStatisticsTable(resp) {
  resp = genearteUniversalIds(resp)
  let dimensions = getDimensionsData(resp)
  let data = getTableData(resp)
  return { data, dimensions }
}
export function getTableData(SolrFile) {
  let headers = Object.keys(SolrFile.values[0]).filter(key => {
    return key !== 'notes' && key !== 'secret'
  })
  let values = SolrFile.values.map(row => {
    // Keep row values aligned with `headers` even when optional fields such as
    // `notes` are present only on some rows.
    let objKeys = headers.map(header => row[header])
    // #bug-308-321:
    // Pasem les notes dins dels "values" (enlloc de pasarles per fora )
    objKeys.notes = row.notes
    objKeys.secret = row.secret
    return objKeys
  })
  // #bug-308-321:
  // En ppi, aquest array "notes" extern ja no serveix de res, xk ja estan dins de "values"
  let notes = SolrFile.values.filter(el => el.notes)
  return { headers, values, notes }
}

function extractNestedTypes(values, labels, result) {
  if (!result) result = []
  if (values.type)
    result.push({
      type: values.type,
      count: values.count,
      label: labels[values.type]
        ? labels[values.type].charAt(0).toUpperCase() + labels[values.type].slice(1)
        : values.type.charAt(0).toUpperCase() + values.type.slice(1),
    })
  if (values.values) {
    values.values.forEach(subvalues => {
      result = result.concat(extractNestedTypes(subvalues, labels))
    })
  }
  return result
    .flat()
    .filter((d, i) => result.findIndex(dd => dd.type === d.type) === i)
    .filter(d => d.type)
    .filter(d => d.type != 'period')
}

import { formatId } from '../utils/formatUtils'

function setTimeLabels(values, dim) {
  values.forEach(v => {
    // if (!v.type && typeof v === 'object') v.type = value.type
    if (!v.label && typeof v === 'object') {
      v.label = formatId(v, dim)
      if (dim.type === 'time') v.timeValue = new Date(v.start)
    } else if (v.type === 'period') {
      v.id = 'period'
    }
    if (v.values) setTimeLabels(v.values, dim)
  })
}
function setTimeDefaults(values, dim) {
  // let orderedTimeOptions = [
  //   'període',
  //   'any',
  //   'curs',
  //   'semestre',
  //   'trimestre',
  //   'bimestre',
  //   'mes',
  //   'setmana',
  //   'dia',
  // ]
  // let indexFound = false
  // orderedTimeOptions.forEach(el => {
  //   if (!indexFound) {
  //     let element = values
  //       .map(function (e) {
  //         return e.values ? e.values[0]?.type.toLowerCase() : null
  //       })
  //       .indexOf(el)
  //     if (element !== -1) {
  //       indexFound = element
  //     }
  //   }
  // })
  // values.forEach(function (type, i) {
  //   if (i === indexFound) {
  //     values.splice(i, 1)
  //     values.unshift(type)
  //   }
  // })
  let max = values.reduce((m, t) => {
    return t.timeValue > m ? t.timeValue : m
  }, values[0].timeValue)
  values.forEach(v => {
    if (typeof v === 'object') {
      if (max && v.timeValue === max) v.defaultSingle = true
      if (v.values) setTimeDefaults(v.values, dim)
    }
  })
}
export function getDimensionsData(data) {
  let fullDims = data.dims
  let dimensions = fullDims.map(d => d.id)
  let dimensionOptions = fullDims.reduce((dict, dim) => {
    setTimeLabels(dim.values, dim)
    setTimeDefaults(dim.values, dim)
    dict[dim.id] = dim.values.map(d => {
      return {
        id: d.id || d,
        label: d.label || d,
        values: d.values || [],
        timeValue: d.timeValue || null,
        type: d.values && !d.id ? null : d.type,
        count: d.count,
      }
    })
    return dict
  }, {})
  let dimensionMetas = fullDims.reduce((dict, d) => {
    dict[d.id] = {}
    dict[d.id].label = d.label
    dict[d.id].id = d.id
    dict[d.id].type = d.type
    let extracted = extractNestedTypes({ values: d.values }, d.labelType)
    dict[d.id].typeOptions = extracted.map(t => {
      let { type, count, label } = t
      return {
        type: type,
        id: type,
        label: label,
        count: count,
      }
    })
    return dict
  }, {})

  return { dimensions, dimensionOptions, dimensionMetas }
}
